import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import FitnessRings from './FitnessRings'
import { FITNESS_METRICS, formatHour } from '../Utils/utils'
import { hourPropType } from '../Utils/types'

const metricKeys = Object.keys(FITNESS_METRICS)
const totalRings = metricKeys.length

const HourlyRing = ({ hourData }) => {
  const inactive = metricKeys.every((key) => (hourData[key]?.target ?? 0) === 0)

  const closedRings = metricKeys.reduce((count, key) => {
    const metric = hourData[key]

    return count + Number(metric.target > 0 && metric.value >= metric.target)
  }, 0)

  return (
    <Box
      sx={{
        width: '100%',
        aspectRatio: '1 / 1',
        flex: '1 1 32px',
      }}
      title={
        inactive
          ? 'Hour not started'
          : `${
              hourData.hour ? `${formatHour(hourData.hour)} ` : ''
            }${closedRings}/${totalRings} closed`
      }
    >
      <FitnessRings stats={hourData} />
    </Box>
  )
}

HourlyRing.propTypes = {
  hourData: hourPropType.isRequired,
}

export default function HourHistory({ hours }) {
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          display: 'block',
          fontSize: 14,
          fontWeight: 'bold',
          mb: 1,
          textTransform: 'uppercase',
        }}
      >
        Hour History
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 0.5,
          width: '100%',
        }}
      >
        {hours.map((hourData, index) => (
          <HourlyRing key={index} hourData={hourData} />
        ))}
      </Box>
    </Box>
  )
}

HourHistory.propTypes = {
  hours: PropTypes.arrayOf(hourPropType).isRequired,
}
